import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { hsaContributionsIntial } from 'enrollment/services';
import {
  HSAContributionCardBackground,
  HSAContributionCardBoder,
  ContributionCardBanner, 
  ContributionCardTitle, 
  ContributionCardDescription
} from './HSAContributionStyled';
import { convertCurrency } from "enrollment/utils";

export function FixedContributionEr(props: any) {
  const { t } = useTranslation('pages.financial');
  const newHSAData = useSelector(hsaContributionsIntial);
  const currentPlanYear = newHSAData.current_plan_year;
  const employerContribution = newHSAData.employer_contribution_details;
  const containerClassName = 'd-flex justify-content-between';
  const nextContributionDate = employerContribution?.next_deduction_date
    ? new Date(employerContribution.next_deduction_date).toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' })
    : 'N/A';

  const employerContributionAmount = Number(employerContribution?.total_org_contribution_amount) + Number(employerContribution?.total_er_lump_sum_contribution_amount);
  const contributionAdjustments = props.contributionAdjustments;
  const isScreenSmall = window.innerWidth < 922;
   
  return (
    <div  data-testid="employer-contribution-fixed">
      <HSAContributionCardBoder>
        <HSAContributionCardBackground>
          <div className="text-center py-3_5">
            <div className={isScreenSmall ? "title-medium font-weight-bold" : "title-large"} data-testid="employer-contribution-amount">
            {convertCurrency(JSON.stringify(employerContributionAmount))}
            </div>
            <div className={isScreenSmall ? "title-small semiBold" : "title-medium semiBold"}>
              {t('newHSA.title', { currentPlanYear })}{' '}
            </div>
            <div className="title-small">{t('newHSA.description')}</div>
          </div>
          {(contributionAdjustments.employerAdjusted && !contributionAdjustments.employerisZero) &&
              <ContributionCardBanner data-testid="employer-contribution-adjusted">
                  <ContributionCardTitle>{t('contributionAdjustments.title')}</ContributionCardTitle>
                  <ContributionCardDescription>{t('contributionAdjustments.employerAdjustedDescription')}</ContributionCardDescription>
              </ContributionCardBanner>
          }
        </HSAContributionCardBackground>
        <div className="my-4 mx-3 employer-contribution-details">
          <div className={`${containerClassName} employerContributionSection`}>
            <div className={isScreenSmall ? "pr-3" : ""}>{t('newHSA.contributionFrequency')}</div>
            <div className="text-capitalize text-right">
              {employerContribution?.contribution_frequency_type}
            </div>
          </div>
          <div className={`${containerClassName} employerContributionSection`}>
            <div className={isScreenSmall ? "text-capitalize pr-3" : "text-capitalize"}>
              {employerContribution?.contribution_frequency_type} {t('newHSA.frequencyLabel')}
            </div>
          <div>
              {convertCurrency(employerContribution?.contribution_frequency_amount)}
            </div>
          </div>
          <div className={`${containerClassName} employerContributionSection`}>
            <div className={isScreenSmall ? "pr-3" : ""}>{t('newHSA.nextDeductionDate')}</div>
            <div>{nextContributionDate}</div>
          </div>
          <div className={`${containerClassName} employerContributionSection`}>
            <div className={isScreenSmall ? "pr-3" : ""}>{t('newHSA.totalContribution')}</div>
            <div>
              {convertCurrency(employerContribution?.total_er_lump_sum_contribution_amount)}
            </div>
          </div>
      </div>
    </HSAContributionCardBoder>
    </div>
  );
}
